export const SPOOF_ORIGINAL_USER_STORAGE_KEY = 'spoof_original_user';

export function readSpoofOriginalUser() {
    if (typeof localStorage === 'undefined') {
        return null;
    }
    try {
        const raw = localStorage.getItem(SPOOF_ORIGINAL_USER_STORAGE_KEY);
        if (!raw || raw === 'null') {
            return null;
        }
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && parsed.id ? parsed : null;
    } catch (_e) {
        return null;
    }
}

export function isSpoofSessionActive() {
    return readSpoofOriginalUser() !== null;
}

export function isSpoofActorSuperAdmin() {
    const original = readSpoofOriginalUser();
    if (!original) {
        return false;
    }
    return !!(original.abilities?.superadmin || original.is_super_admin);
}

export function canSpoofTarget(authUser, targetUser) {
    if (!authUser?.id || !targetUser?.id || authUser.id === targetUser.id) {
        return false;
    }
    if (isSpoofSessionActive()) {
        return false;
    }
    if (targetUser.isSuperAdmin?.() || targetUser.is_super_admin) {
        return false;
    }
    if (authUser.isSuperAdmin?.()) {
        return true;
    }
    return authUser.can('spoof', 'users');
}
